import { Component, HostListener, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { commonErrorMessage, technologyErrorPageMessage } from 'src/app/constants/error-message-constant';
import { ParentTechnologyPreferenctConstant } from 'src/app/constants/label-constants';
import { CommonService } from 'src/app/services/common/common.service';
import { DirtycheckDialogboxComponent } from '../../dirtycheck-dialogbox/dirtycheck-dialogbox.component';

@Component({
  selector: 'app-add-parent-technology-preference',
  templateUrl: './add-parent-technology-preference.component.html',
  styleUrls: ['./add-parent-technology-preference.component.scss']
})
export class AddParentTechnologyPreferenceComponent {
  ParentTechnologyForm: FormGroup = this.formBuilder.group({});
  @Input() ParentTechnologyPreferenceId: any;
  CommonConstant: any = [];
  ParentTechnologyConstant: any = [];
  ParentTechnologyPhoto: any;
  ParentTechnologyLogo: string = '';
  flag: boolean = true;
  errorMessage: any = [];
  commonErrorMessage: any = [];
  modalButton: boolean = false;
  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: BeforeUnloadEvent): void {
    if (this.ParentTechnologyForm.dirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }

  constructor(
    private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private toastr: ToastrService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    public modalService: NgbActiveModal,
    public ModalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.CommonConstant = CommonConstant;
    this.ParentTechnologyConstant = ParentTechnologyPreferenctConstant;
    this.errorMessage = technologyErrorPageMessage;
    this.commonErrorMessage = commonErrorMessage;
    this.onInitParentTechnolgyForm();
    if (this.ParentTechnologyPreferenceId > 0) {
      this.getParentTechnologyDetail(this.ParentTechnologyPreferenceId);
    }
    else {
      this.ParentTechnologyPreferenceId = 0;
    }
  }

  onInitParentTechnolgyForm() {
    this.ParentTechnologyForm = this.formBuilder.group({
      ParentTechnologyPreferenceId: [0],
      ParentTechnologyName: ['', [Validators.required, Validators.maxLength(100)]],
      ParentTechnologyLogo: ['']
    });
  }

  get ParentTechnologyFormControl() {
    return this.ParentTechnologyForm.controls;
  }

  onCancel() {
    if (this.ParentTechnologyForm.dirty) {
      const modalRef = this.ModalService.open(DirtycheckDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.ParentTechnologyForm = this.ParentTechnologyForm;
    }
    else {
      this.modalService.close();
    }
  }

  getParentTechnologyDetail(ParentTechnologyId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.ParentTechnologyPreferences.TechnlogyPreferenceById.replace("{id}", ParentTechnologyId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.spinner.hide();
        if (data.data.logo) {
          (<HTMLInputElement>document.getElementById('ParentTechnologyPreview')).setAttribute("src", data.data.logo);
        }
        else {
          (<HTMLInputElement>document.getElementById('ParentTechnologyPreview')).setAttribute("src", "assets/img/logo_placeholder.svg");
        }
        this.setParentTechnologyForm(data.data);
      },
      error: (err) => {
        console.log('getParentTechnologyDetail-Error', err);
      }
    });
  }

  setParentTechnologyForm(data) {
    this.ParentTechnologyForm.setValue({
      ParentTechnologyPreferenceId: (data.technologyPreferenceId) ? data.technologyPreferenceId : 0,
      ParentTechnologyName: data.name,
      ParentTechnologyLogo: data.logo ? data.logo : ''
    });
    this.ParentTechnologyLogo = data.logo;
  }

  saveParentTechnology() {
    this.modalButton = true;
    if (!this.ParentTechnologyForm.valid) {
      return;
    }
    this.spinner.show();
    const form = new FormData();
    this.spinner.show();
    form.append('technologyPreferenceId', this.ParentTechnologyForm.value.ParentTechnologyPreferenceId ? this.ParentTechnologyForm.value.ParentTechnologyPreferenceId.toString() : '0');
    form.append('name', this.ParentTechnologyForm.value.ParentTechnologyName.trim());
    form.append("logoFile", this.ParentTechnologyPhoto);
    form.append("logo", this.ParentTechnologyLogo);
    const apiUrl = this.apiUrl.apiUrl.ParentTechnologyPreferences.SaveTechnologyPreference;
    this.CommonService.doPost(apiUrl, form).pipe().subscribe({
      next: (data) => {
        if (data.success) {
          this.modalButton = false;
          this.spinner.hide();
          this.modalService.close('save');
          if(this.ParentTechnologyPreferenceId > 0){
            this.toastr.success("Parent technology preference updated successfully");
          }
          else{
            this.toastr.success(data.message);
          }
        }
        else {
          this.spinner.hide();
          this.toastr.error(data.message);
          this.modalButton = false;
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }

  onFileChanged(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      let file: any;
      var ext = event.target.files[0].name.match(/\.([^\.]+)$/)[1];
      switch (ext.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'png':
          break;
        default:
          this.toastr.error("Please select only JPG,JPEG or PNG Image");
          (<HTMLInputElement>document.getElementById('uploadParentTechnologyImage')).value = "";
          return true;
      }
      reader.onload = function (e) {
        file = e.target;
        (<HTMLInputElement>document.getElementById('ParentTechnologyPreview')).setAttribute("src", file.result);
      }
      reader.readAsDataURL(event.target.files[0]);
      this.ParentTechnologyPhoto = event.target.files[0];
    } else {
      (<HTMLInputElement>document.getElementById('ParentTechnologyPreview')).setAttribute("src", "assets/img/logo_placeholder.svg");
      this.ParentTechnologyPhoto = null;
      (<HTMLInputElement>document.getElementById('uploadParentTechnologyImage')).value = '';
      this.ParentTechnologyPhoto.controls['ParentTechnology'].setValue('');
    }
  }
}
